// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"c388ed83","494":"e3997b99","551":"ee8db5b1"}[chunkId] + ".chunk.js";
};